import { ComponentNode } from '../types/template';
import { fetchRawDataForRenderRequest } from '../utils/DataFetcher';
import OfferBannerSlider from './OfferBannerSlider';

interface OfferBannerSectionComponentProps {
    component: ComponentNode;
    context?: {
        companyId?: string;
        domain?: string;
    };
}

export interface OfferBannerItem {
    banner_image: string;
    offer_url: string;
}

const normalizeOfferBanners = (response: any): OfferBannerItem[] => {
    const offers: any[] = response?.data?.offers ?? [];
    return offers
        .map((item: any) => ({
            banner_image: item.offer?.banner_image ?? '',
            offer_url: item.offer?.url ?? '#',
        }))
        .filter((item) => item.banner_image);
};

const OfferBannerSectionComponent = async ({ component, context }: OfferBannerSectionComponentProps) => {
    const request = component.apiConfig ?? component.apiEndpoint;
    if (!request) return null;

    const response = await fetchRawDataForRenderRequest(request, {
        companyId: context?.companyId,
        domain: context?.domain,
    });

    const items = normalizeOfferBanners(response);
    if (!items.length) return null;

    const imageHeight = (component.components?.[0]?.components?.[0]?.styles?.height as string) ?? '200px';

    return (
        <OfferBannerSlider
            items={items}
            totalCards={component.totalCards}
            imageHeight={imageHeight}
            sectionStyles={component.styles}
            sliderEnabled={component.sliderEnabled}
            autoPlay={component.autoPlay}
            slideInterval={component.slideInterval}
        />
    );
};

export default OfferBannerSectionComponent;
